<div class="box ml-2">
  <div class="box-header">


  </div>

  <!-- add user -->
  <div class="flex-align-center py-2 px-3" >
    <span class="font-weight-bold title-lg mr-12" >{{'Store' | translate }}  &nbsp; </span>

    <span class="font-weight-bold title-lg" >{{storeNumber}} </span>
    <button mat-stroked-button class="ml-auto" (click)="backToSummary()">
      <mat-icon>groups</mat-icon>
      {{'Back to Stores' | translate}}
    </button>
  </div>
  <div class="box-body ml-2 mr-2" >
    <form [formGroup]="storeEditForm">
      <div class="col">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label >{{'Store #' | translate}}</mat-label>
              <input matInput maxlength="50" formControlName="storeNumber" required readonly/>
              <mat-error>
                {{ storeEditForm.get('storeNumber').getError('invalid') }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Licence' | translate}}</mat-label>
              <input maxlength="50" appUserLicense formControlName="storeLicenseNumber" matInput required/>
              <mat-error>
                @if (storeEditForm.get('storeLicenseNumber').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
                <!-- {{ storeEditForm.get('storeLicenseNumber').getError('invalid') }} -->
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Pharmacy Name' | translate}}</mat-label>
              <input matInput maxlength="100" appStoreName formControlName="storeName" />
              <mat-error>
                @if (storeEditForm.get('storeName').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
                <!-- {{ storeEditForm.get('storeName').getError('invalid') }} -->
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col hide-sm"></div>
        </div>
        <div class="row">
          <!-- <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Street Address' | translate}}</mat-label>
            <input matInput maxlength="50" streetAddressVallidation required formControlName="storeAddress" />
            <mat-error>
              <span *ngIf="storeEditForm.get('storeAddress').getError('invalid')">
                Invalid Input
              </span>
              <!-- {{ storeEditForm.get('storeAddress').getError('invalid') }}
            </mat-error>
          </mat-form-field>
        </div> -->
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Civic Number' | translate}}</mat-label>
            <input matInput maxlength="50" alphaNumericValidator formControlName="civicNumber" />
            <mat-error>
              @if (storeEditForm.get('civicNumber').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('civicNumber').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Suite Number' | translate}}</mat-label>
            <input matInput maxlength="50" alphaNumericValidator formControlName="suiteNumber" />
            <mat-error>
              @if (storeEditForm.get('suiteNumber').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('suiteNumber').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col hide-sm"></div>
        <div class="col hide-sm"></div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Street Name' | translate}}</mat-label>
            <input matInput maxlength="50" streetAddressVallidation required formControlName="streetName" />
            <mat-error>
              @if (storeEditForm.get('streetName').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('streetName').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Street Type' | translate}}</mat-label>
            <input matInput maxlength="50" alphaNumericValidator formControlName="streetType" />
            <mat-error>
              @if (storeEditForm.get('streetType').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('streetType').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Street Direction' | translate}}</mat-label>
            <input matInput maxlength="50" charsOnlyValidator formControlName="streetDirection" />
            <mat-error>
              @if (storeEditForm.get('streetDirection').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('streetDirection').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col hide-sm"></div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'City' | translate}}</mat-label>
            <input matInput required maxlength="100" (input)="storeEditForm.controls.city.setValue(storeEditForm.controls.city.value.toUpperCase())" cityvalidation formControlName="city" />
            <mat-error>
              @if (storeEditForm.get('city').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('city').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'Province' | translate}}</mat-label>
            <input matInput required maxlength="2" appProvinceCode  minlength="2"  (input)="storeEditForm.controls.provinceCode.setValue(storeEditForm.controls.provinceCode.value.toUpperCase())" formControlName="provinceCode" />
            <mat-error>
              @if (storeEditForm.get('provinceCode').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('provinceCode').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{'Postal Code' | translate}}</mat-label>
            <input matInput required maxlength="7" appPostalCode formControlName="postalCode"  [value]="storeEditForm.get('postalCode').value | uppercase"/>
            <mat-error>
              @if (storeEditForm.get('postalCode').getError('invalid')) {
                <span>
                  {{'Invalid Input' | translate}}
                </span>
              }
              <!-- {{ storeEditForm.get('postalCode').getError('invalid') }} -->
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'DC Location' | translate}}</mat-label>
            <input matInput required maxlength="5" type="number" formControlName="dcNumber" />
            <mat-error>
              {{ storeEditForm.get('dcNumber').getError('invalid') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="store-emails-field" appearance="outline">
            <mat-label>{{'Store Email Accounts' | translate}}</mat-label>
            <mat-chip-grid #chipList formControlName="storeEmails">
              @for (emailId of emails; track emailId) {
                <mat-chip-row class="{{emailId.invalid? 'chip-invalid': ''}}"
                  [removable]="removable" (removed)="remove(emailId.value)">
                  {{emailId.value}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
              <input placeholder="{{'New Email Id' | translate}}"
                [matChipInputFor]="chipList"

                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            @if (storeEditForm.get('storeEmails').errors?.incorrectEmail) {
              <mat-error>
                {{ 'Invalid Email highlight in red' | translate }}
              </mat-error>
            }
            @if (storeEditForm.get('storeEmails').errors?.invalid) {
              <mat-error>
                {{ 'Invalid Email' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="hide-sm"></div>
        <div class="hide-sm"></div>
      </div>

      <div class="col">
        <mat-form-field appearance="outline" style="width: 45%!important;">
          <mat-label>{{'Notes' | translate}}</mat-label>
          <textarea matInput formControlName="notes"
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10">
          </textarea>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline" style="width: 21.5%!important;">
          <mat-label>{{'Last Updated' | translate}}</mat-label>
          <input matInput required maxlength="24"  formControlName="lastUpdatedTime" readonly/>
        </mat-form-field>
      </div>

      <div class="row form-group flex-align-center">

        <div class="col text-right">
          <button mat-raised-button color="primary" [disabled]="!storeEditForm.valid" (click)="updateStoreData()">{{'Save' | translate}}</button>
          @if (errorMessage) {
            <div style="color:red; font-size: large;">{{errorMessage}}</div>
          }
        </div>
      </div>
    </div>
  </form>
</div>
</div>

